export default __webpack_public_path__ + "static/media/warning-icon.b39e9a40.svg";